import React, { useMemo, useState } from 'react';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';

import LayoutContainer from '../components/LayoutContainer';
import VideoItem from '../../video-item/VideoItem';

import {
  selectOrientaion,
  selectVideoGridIds,
  selectParticipants,
  selectUserParticipant,
  selectVideoHideSelf,
  selectConfig,
} from '../../../../../selectors';

import {
  LAYOUT_TYPE_GRID,
  LAYOUT_ROTATE_LAND,
  LAYOUT_ROTATE_VERT,
} from '../../../../../constants';

const useStyles = makeStyles(() => ({
  grid: {
    overflowX: 'hidden',
    overflowY: 'hidden',
    textAlign: 'center',
    transition: 'all 0.3s ease-in-out',
  },
  selfVideoV: {
    right: '1%',
    bottom: '-3%',
    width: '30%',
    position: 'absolute',
  },
}));

const MobileGridLayout = () => {
  const classes = useStyles();
  const orientation = useSelector(selectOrientaion);
  const videoGridIds = useSelector(selectVideoGridIds);
  const participants = useSelector(selectParticipants);
  const participantSelf = useSelector(selectUserParticipant);
  const videoHideSelf = useSelector(selectVideoHideSelf);
  const videoGridLimit = useSelector((state) => selectConfig(state, 'PORTAL_MIV_VIDEO_LIMIT')) || 7;

  const landscape = useMemo(() => orientation === LAYOUT_ROTATE_LAND, [orientation]);
  console.log(`Orientation:${orientation} landscape:${landscape}`);

  const [totalParts, setTotalParts] = useState(0);

  const participantIds = useMemo(() => {
    const filtered = videoGridIds.filter((id) => _.get(participants, [id, 'videoTrackMuted']) !== true);
    setTotalParts(filtered.length);
    if (filtered.length % 2 !== 0) {
      return [filtered.slice(0, 1), filtered.slice(1, Number(videoGridLimit))];
    }
    return [null, _.take(filtered, Number(videoGridLimit) + 1)];
  }, [videoGridIds]);

  return (
    <LayoutContainer>
      <Grid
        container
        wrap="wrap"
        justifyContent="center"
        alignContent="center"
        columns={orientation === LAYOUT_ROTATE_VERT ? 12 : 48}
        className={classes.grid}
      >
        { participantIds[0] && (
          <Grid
            item
            key={participantIds[0]}
            xs={12}
            sm={12}
          >
            <VideoItem participantId={participantIds[0]} layout={LAYOUT_TYPE_GRID} />
          </Grid>
        )}
        {participantIds[1].map((id) => (
          <Grid
            item
            key={id}
            xs={totalParts > 2 ? 6 : 12}
            sm={totalParts > 2 ? 6 : 12}
          >
            <VideoItem
              participantId={id}
              isMobileCrop={totalParts > 2 || (totalParts === 2 && participantIds[0])}
              layout={LAYOUT_TYPE_GRID}
            />
          </Grid>
        ))}
      </Grid>
      { !videoHideSelf && (
      <div
        className={classes.selfVideoV}
      >
        <VideoItem
          participantId={participantSelf.id}
          layout={LAYOUT_TYPE_GRID}
          isTrayItem
          isMobileCrop
        />
      </div>
      )}
    </LayoutContainer>
  );
};

export default MobileGridLayout;
